import React, { Component } from 'react';
import './artistDashboard.css';
import Logo from '../Images/RedLogoLandscape.svg';
import * as firebase from 'firebase';
import Gigitem from './GigItem';
import AddGig from './AddGig';
import Button from '../Common/Button';
import _ from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import AddArtistInfo from './AddArtistInfo';

class ArtistDashboard extends Component {

    constructor() {
        super();
        this.state = {
            user: null,
            gigs: [],
            artistInfo: {},
            isLoading: true
        };
        dayjs.locale('en-gb');
    }

    componentDidMount() {
        this.removeAuthListener = firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                this.setState({ user: true, isLoading: false });
                this.getData();
            }
            else {
                this.setState({ user: false, isLoading: false });
            }
        });
    }

    componentWillUnmount() {
        this.removeAuthListener();
    }

    getData = async () => {

        if(this.state.user) {
            const uid = await firebase.auth().currentUser.uid;
            const data = await firebase.firestore().collection('users').doc(uid).collection('gigs').get();
            console.log('got data!', data);

            const gigData = data.docs.map((doc) => {
                return { id: doc.id, ...doc.data() };
            });
    
            this.setState({ gigs: gigData })
        }
        
    }

    addGig = async (gig) => {
        
        const uid = await firebase.auth().currentUser.uid;
        console.log('my userid:', uid);
        let gigRef = await firebase.firestore().collection('users').doc(uid).collection('gigs').add(gig);
        console.log('gig ref', gigRef)

        const newGig = {
            id: gigRef.id,
            ...gig
        }
        this.setState({ gigs: [newGig, ...this.state.gigs]  });
    };

    removeGig = async (id) => {
        const uid = await firebase.auth().currentUser.uid;
        firebase.firestore().collection('users').doc(uid).collection('gigs').doc(id).delete();
        let newGigList = this.state.gigs;
        
        newGigList = _.remove(newGigList, (gig) => {
            console.log(gig.id, id);
            return gig.id !== id
        });
        
        this.setState({ 
            gigs: newGigList
        });
    };

    signIn = () => {    
        var provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().signInWithPopup(provider).then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            // The signed-in user info.
            var user = result.user;
            // this.setState({ user: result.user });
            console.log('user:', user.uid)
            // ...
        }).catch((error) => {

            console.log('error', error)
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
        });

    }

    updateArtistInfo = (data) => {

    }

    render() {
        if(this.state.isLoading) {
            return (
                <div className="artistDashboard__container">
                    <img src={Logo} alt="prospector records" className="artistDashboard__logo" />
                    <div className="artistDashboard__main">
                        Loading...
                    </div>
                </div>
            );           
        }

        let gigList = this.state.gigs;
        if(gigList && gigList.length > 0) {
            gigList = _.orderBy(gigList, (gig) => {
                return dayjs(gig.date).locale('en-gb').get('date');
            });
        }

        let artistInfo = this.state.artistInfo;

        return (
            <div className="artistDashboard__container">
                <img src={Logo} alt="prospector records" className="artistDashboard__logo" />
                
                <div className="artistDashboard__main">
                    {!this.state.user && (<span>Login to manage your artist page.</span>)}

                    <div className="artistDashboard__button">
                        {!this.state.user ? (<Button onClick={this.signIn}>Login</Button>) : (<Button style="secondary" onClick={() => firebase.auth().signOut()}>Sign Out</Button>)}
                    </div>


                    {this.state.user && (
                        <div className="artistDashboard__infoAndGigs">
                            <div className="artistDashboard__info">
                                <AddArtistInfo info={this.state.artistInfo} updateInfo={this.updateArtistInfo}/>
                            </div>
                            <div className="artistDashboard__gigs">
                                <AddGig onSubmit={this.addGig} />
                                {this.state.gigs && (
                                    <>
                                        <div>
                                            <div className="artistDashboard__gigList--header">Your Gigs</div>
                                            <div className="artistDashboard__gigList--headerContainer">
                                                <div className="artistDashboard__gigList--tableHeader">Name</div>
                                                <div className="artistDashboard__gigList--tableHeader">Location</div>
                                                <div className="artistDashboard__gigList--tableHeader">Date</div>
                                                <div className="artistDashboard__gigList--tableHeader">Notes</div>
                                            </div>
                                        </div>
                                        <div className="artistDashboard__gigContainer">
                                            {this.state.user && gigList && (
                                                _.map(gigList, (gig) => (              
                                                    <Gigitem gig={gig} removeGig={this.removeGig}/>                               
                                                ))
                                                
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}


                    

                    
                    
                </div>

                

            </div>
        );
    }
}

export default ArtistDashboard;
